import React from 'react';
import { Icon } from '@rsuite/icons';
import PageIcon from '@rsuite/icons/Page';
import { Outlet } from 'react-router-dom';
import TermsModal from '../tos-modal/TermsModal';
import usePlaceNavigate from 'src/hooks/usePlaceNavigate';
import { useTOSStatus } from '../tos-modal/useTOSStatus';
import { selectCurrentIDToken } from 'src/store/slices/auth/authSelectors';
import { useSelector } from 'react-redux';

const TOSRoutes = [
  '/dashboard',
  '/apply-requirements',
  '/account-update',
  '/single-permit',
  '/tax-report-revenue',
];

const Layout = () => {
  const placeNavigate = usePlaceNavigate();
  const accessToken = useSelector(selectCurrentIDToken);
  const { display, content, isLoading, acknowledgeTOS, declineTOS } =
    useTOSStatus(TOSRoutes, accessToken);

  const onAcceptTerms = async () => {
    acknowledgeTOS();
  };
  const onDeclineTerms = async () => {
    declineTOS();
    placeNavigate('/dashboard'); // Redirect to the dashboard page
  };

  return (
    <>
      <Outlet />
      <TermsModal
        onAcceptTerms={onAcceptTerms}
        onDeclineTerms={onDeclineTerms}
        open={display}
        isLoading={isLoading}
        title="Terms of Service and Privacy Policy"
      >
        <p>
          To use this Portal, you need to agree to the Terms of Service and
          Privacy Policy. Please click on the links below to read them to read
          the Terms of Service and Privacy Policy documents.
        </p>
        <div style={{ padding: '20px 18px 0' }}>
          <p>
            <Icon
              style={{ marginRight: '8px', fontSize: '28px', color: '#e99 ' }}
              className="text-primary"
              as={PageIcon}
            />
            <a
              href={content?.pdfLink}
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>
          </p>
          <p>
            <Icon
              style={{ marginRight: '8px', fontSize: '28px', color: '#e99' }}
              className="text-primary"
              as={PageIcon}
            />
            <a
              href="https://app.termly.io/policy-viewer/policy.html?policyUUID=b6219f58-5bc6-4d88-8595-89887d2e0900"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </TermsModal>
    </>
  );
};

export default Layout;
